import { updateLinksAttributes } from '../utils/handleAttributes';
import { missingWidget } from '../utils/helpers';

export default function headerButton(itemId, itemOpts, _isAlt) {
  const widgetName = itemId;
  const $widget = $(`#${widgetName}`);
  const widgetOpts = itemOpts;

  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createHeaderButton(data);
      } else {
        $widget.remove();
      }
    },
  });

  function createHeaderButton(widgetData) {
    const { Title, URL } = widgetData.items[0];

    if (URL == null) {
      missingWidget(widgetName);
      $widget.remove();
      return;
    }
    $widget.replaceWith(
      `<a id="${widgetName}" class="${_isAlt ? 'button alternative-btn' : 'button'}" tabindex="0" href="${URL}" ${updateLinksAttributes(URL, Title)}>
        ${Title}
      </a>`,
    );
  }
}
